var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4999 9C15.4999 10.933 13.9329 12.5 11.9999 12.5C10.0669 12.5 8.49988 10.933 8.49988 9C8.49988 7.067 10.0669 5.5 11.9999 5.5C13.9329 5.5 15.4999 7.067 15.4999 9Z",
    fill: "#24292E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.500122C8.5681 0.500122 5.8755 2.03429 3.94591 3.74074C2.02028 5.44368 0.814406 7.35141 0.329595 8.20137C0.0449209 8.70046 0.0449199 9.29979 0.329594 9.79887C0.814405 10.6488 2.02028 12.5566 3.94591 14.2595C5.8755 15.966 8.5681 17.5001 12 17.5001C15.4319 17.5001 18.1245 15.9659 20.0541 14.2595C21.9797 12.5565 23.1856 10.6488 23.6704 9.79879C23.955 9.2997 23.955 8.70038 23.6704 8.2013C23.1856 7.35135 21.9797 5.44363 20.0541 3.74071C18.1245 2.03428 15.4319 0.500122 12 0.500122ZM1.63254 8.94456C2.07402 8.17057 3.18409 6.41688 4.9396 4.86438C6.69114 3.3154 9.04487 2.00012 12 2.00012C14.9552 2.00012 17.3089 3.31539 19.0604 4.86435C20.8159 6.41683 21.926 8.1705 22.3674 8.94449C22.3805 8.96748 22.3839 8.98606 22.3839 9.00005C22.3839 9.01405 22.3805 9.03262 22.3674 9.05561C21.926 9.82961 20.8159 11.5833 19.0604 13.1358C17.3089 14.6848 14.9552 16.0001 12 16.0001C9.04487 16.0001 6.69114 14.6848 4.9396 13.1359C3.18409 11.5834 2.07402 9.82968 1.63254 9.05568C1.61942 9.03269 1.61609 9.01412 1.61609 9.00012C1.61609 8.98613 1.61942 8.96756 1.63254 8.94456Z",
    fill: "#24292E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowIcon);
export default __webpack_public_path__ + "static/media/show-icon.d276c65a.svg";
export { ForwardRef as ReactComponent };